!/**
* @Description: 对比测试
* @author Wangshu
* @date 2020/2/24
*/
<template>
  <div>
    <PopBook>
      <template slot="header">
        <div class="pop-title">对比测试</div>
        <div class="pop-btn">
          <img class="btn" @click="$router.go(-1)" src="@/assets/img/grammarTest/close.png" alt />
        </div>
        <div class="line"></div>
      </template>
      <template slot="content">
        <div class="content-box user-box">
          <transition name="el-fade-in-linear" mode="out-in">
            <div class="content-area">
              <div class="content-tit">所谓对比，学前选择什么单位，学后就对比什么单元（1.单元选择测试单元>2.开始测试）</div>
              <!--有比分-->
              <div
                class="compare-logo"
                v-if="testBtnStatus.is_before==0||testBtnStatus.is_before==1"
              >
                <div class="score">{{testBtnStatus.before_score}}</div>
                <img src="@/assets/img/grammarTest/vs.png" alt />
                <div class="score">{{testBtnStatus.after_score}}</div>
              </div>
              <!--没有比分-->
              <div class="compare-logo" v-else>
                <img src="@/assets/img/grammarTest/ask.png" alt />
                <img src="@/assets/img/grammarTest/vs.png" alt />
                <img src="@/assets/img/grammarTest/ask.png" alt />
              </div>
              <!--单元列表-->
              <div class="cell-list">
                <div
                  class="cell-item"
                  :class="[item.is_try==0?'lock-cell-item':'']"
                  v-if="comparisonUnitList"
                  v-for="(item,index) in comparisonUnitList"
                  :key="index"
                  @click="selectUnit(index,item.id)"
                >
                  <div
                    :class="[selectIndex==index&&item.is_try!=0?'active-item':'','animate-item']"
                  >
                    <span>{{item.name}}</span>
                  </div>
                </div>
                <div v-if="comparisonUnitList==''" class="not-data">
                  <div>
                    <img src="@/assets/img/word/not_find_data.png" alt />
                    <span>暂时木有内容呀 ~ ~</span>
                  </div>
                </div>
              </div>
              <div class="foot-btn">
                <el-button
                  v-if="testBtnStatus.is_before=='1'"
                  type="success"
                  @click="startComparisonTest(1)"
                >学前测试</el-button>
                <el-button
                  v-if="testBtnStatus.is_after=='0'"
                  type="success"
                  @click="startComparisonTest(2)"
                >学后测试</el-button>
                <el-button
                  v-if="testBtnStatus.is_after=='1'"
                  type="success"
                  @click="startComparisonTest(2)"
                >刷新成绩</el-button>
                <el-button type="danger" @click="$router.go(-1)">关闭页面</el-button>
              </div>
            </div>
          </transition>
        </div>
      </template>
    </PopBook>

    <transition name="el-fade-in-linear" mode="out-in">
      <test-paper
        ref="testPaper"
        :type="testPaperType"
        :showComparison="showComparison"
        :option="option"
        @closeComparison="closeText"
      ></test-paper>
    </transition>
  </div>
</template>

<script>
import testPaper from "../../templates/unitTest/testPaper";
import Lockr from "lockr";
import { getUnitList, searchComparisonTestGrade } from "@/api/grammar";

export default {
  components: { testPaper },
  data() {
    return {
      comparisonUnitList: "", //对比测试单元列表
      selectIndex: "-1", //是否选中
      showComparison: false,
      showTestBtn: false, //是否展示开始测试按钮
      testPaperType: "3", //控制组件使用的接口(对比测试相关的接口)
      option: {
        name: "对比测试",
        testPaperId: "", //单元Id
        category: "", //1学前测试，2学后测试
      },
      testBtnStatus: {},
    };
  },
  methods: {
    getComparisonList() {
      let params = {
        token: Lockr.get("token"),
        grammar_curriculum_id: this.$route.query.id,
        type: 3,
      };
      getUnitList(params).then((res) => {
        this.comparisonUnitList = res.data;
      });
    },

    // 选择单元
    selectUnit(index, unitId) {
      this.option.testPaperId = unitId;
      if (this.comparisonUnitList[index].is_try != 0) {
        let params = {
          token: Lockr.get("token"),
          unit_id: this.option.testPaperId,
        };
        searchComparisonTestGrade(params).then((res) => {
          this.testBtnStatus = res.data;
        });
      } else {
        this.testBtnStatus = "";
        this.showTestBtn = false;
      }
      this.selectIndex = index;
    },
    // 开始对比测试
    startComparisonTest(type) {
      this.option.category = type;
      this.showComparison = true;
      this.$refs.testPaper.getTestPaper();
    },
    // 关闭对比测试
    closeText() {
      this.showComparison = false;
    },
  },
  created() {
    this.getComparisonList();
  },
};
</script>

<style scoped lang='less'>
.content-box {
  transition: all 0.5s;
  width: 100%;
    min-height: 460px;
  .content-area {
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  .content-tit {
    margin: 20px;
    border-radius: 4px;
    border: 1px solid rgba(245, 166, 35, 1);
    padding: 12px 25px;
    font-size: 14px;
    font-weight: bold;
    color: #333;
  }

  .compare-logo {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 15px;
    height: 70px;

    img {
      height: 50px;
      margin: 0 30px;
    }

    .score {
      font-size: 70px;
      color: #fa4860;
    }
  }

  .cell-list {
      margin: 0 20px;
    flex: 1;
    padding: 10px;
    margin-top: 20px;
    border: 1px solid #dcdcdc;
    overflow-x: hidden;
    overflow-y: scroll;
    .cell-item {
        float: left;
      width: 18%;
      color: #fff;
      height: 75px;
      font-size: 19px;
      cursor: pointer;
      margin: 10px 1%;
      position: relative;
      transition: 0.3s ease-in-out, visibility 0s;
      background: linear-gradient(
        270deg,
        rgba(255, 197, 103, 1) 0%,
        rgba(255, 157, 0, 1) 100%
      );

      .left-logo {
        height: 40px;
      }

      .star {
        position: absolute;
        right: 2px;
        bottom: 2px;
        width: 20px;
        height: 20px;
      }
    }

    .animate-item {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      width: 100%;
      transition: 0.3s ease-in-out, visibility 0s;
    }

    .active-item {
      background-image: url("../../../../assets/img/grammarTest/star.png");
      background-position: 97% 89%;
      background-repeat: no-repeat no-repeat;
      background-size: 25px 25px;
    }

    .cell-item:hover {
      box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.5);
    }

    .lock-cell-item {
      background: #818181;
      position: relative;

      .lock {
        width: 16px;
        position: absolute;
        bottom: 3px;
        right: 3px;
      }
    }

    .not-data {
      width: 100%;
      height: auto;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      color: #666;

      > div {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        img {
          margin-bottom: 10px;
        }
      }
    }
  }

  /*.btn1, .btn2 {*/
  /*    top: 35px;*/
  /*}*/

  .foot-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px 0;

    > div {
      display: flex;
      margin-right: 10px;
    }
  }
}

.btn1,
.btn2 {
  top: 26px !important;
}
@media (max-width: 1198px) {

  .content-box {
    display: flex;
    flex-direction: row;
    width: 100%;
    .compare-logo {
      height: 50px;
      img {
        height: 30px;
        margin: 0 25px;
      }

      .score {
        font-size: 60px;
        color: #fa4860;
      }
    }
  }
}
</style>